// @flow
import React from 'react';
import styled from 'styled-components';
import { colors } from '@atlaskit/theme';

import { Dimensions } from 'components/visuals';
import TopMenu from 'components/navigation/top/TopMenu';
import SearchBox from 'components/navigation/top/SearchBox';
import TopLogo from 'components/navigation/top/TopLogo';
import LoginStatus from 'components/navigation/top/LoginStatus';
import ActiveDropdown from 'components/navigation/top/dropdowns/ActiveDropdown';

const HeaderSection = styled.section`
  width: 100%;
  background: ${colors.N0};
`;

const HeaderLine = styled.header`
  padding-top: ${Dimensions.units(1)}px;
  margin: 0 auto;
  color: ${colors.N500};
  position: relative;
`;

export default () => (
  <HeaderSection>
    <HeaderLine>
      <LoginStatus />
    </HeaderLine>
    <HeaderLine>
      <TopLogo />
      <TopMenu />
      <SearchBox />
    </HeaderLine>
    <HeaderLine>
      <ActiveDropdown />
    </HeaderLine>
  </HeaderSection>
);
